import { render, staticRenderFns } from "./TermEnd.vue?vue&type=template&id=81957e60"
import script from "./TermEnd.vue?vue&type=script&lang=js"
export * from "./TermEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports